"use client";

import type { AuthState, LoginCredentials } from "./types";
import { clearJmapAccountCache } from "@/lib/jmap/account";
import { clearIdentityCache } from "@/lib/jmap/identity";

export async function login(credentials: LoginCredentials): Promise<{ ok: boolean; error?: string }> {
  const res = await fetch("/api/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
    credentials: "include",
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    return { ok: false, error: body.error ?? "Login failed" };
  }
  clearJmapAccountCache();
  clearIdentityCache();
  return { ok: true };
}

export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
  clearJmapAccountCache();
  clearIdentityCache();
}

export async function fetchAuthState(): Promise<AuthState> {
  const res = await fetch("/api/auth/session", { credentials: "include" });
  if (!res.ok) {
    return { authenticated: false, email: null, accountId: null, loading: false };
  }
  const data = (await res.json()) as { email: string; accountId?: string };
  return {
    authenticated: true,
    email: data.email,
    accountId: data.accountId ?? null,
    loading: false,
  };
}

export async function refreshSession(): Promise<boolean> {
  const res = await fetch("/api/auth/refresh", { method: "POST", credentials: "include" });
  return res.ok;
}
